module.exports = __webpack_public_path__ + "img/idle.bce97d9b.png";